module.exports = __webpack_public_path__ + "src/assets/img/share/tips/pleasant/00986bbee3b018cdbef85711fd0f2baf.png";